var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center",class:{'fullscrean': _vm.fullscrean}},[_c('div',[_c('div',{staticClass:"dot-flashing"}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.text),expression:"text"}],staticClass:"small text-theme font-weight-bold mt-3"},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }